export default __webpack_public_path__ + "static/media/blog-4-300x250.d587a50e.png";